import { render, staticRenderFns } from "./ConfigCancelOrder.vue?vue&type=template&id=66e7d182"
import script from "./ConfigCancelOrder.vue?vue&type=script&lang=js"
export * from "./ConfigCancelOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports